export default __webpack_public_path__ + "static/media/DevelopersCoffee+.a570be14.svg";